import { EditBigIcon } from '@fingertip/icons'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'

type Props = {
  siteSlug: string
  pageSlug: String
}

export const EditPageButton = ({ siteSlug, pageSlug }: Props) => {
  const { t } = useTranslation()
  return (
    <Link
      href={`/sites/${siteSlug}/pages${pageSlug !== 'index' ? `?pageSlug=${pageSlug}` : ''}`}
    >
      <div className="flex items-center gap-1.5 hover:text-primary transition-colors">
        <EditBigIcon className="size-4 shrink-0" />
        {t('edit_pages')}
      </div>
    </Link>
  )
}
